import { ListagemConteudoEletronicoComponent } from './../listagem-conteudo-eletronico/listagem-conteudo-eletronico.component';
import { ConteudoModel } from './../../../model/caixa/conteudo.model';
import { ConteudoService } from './../../../service/caixa/conteudo.service';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { MatIconRegistry } from '@angular/material/icon';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';


@Component({
  selector: 'app-exibir-conteudo-caixa',
  templateUrl: './exibir-conteudo-caixa.component.html',
  styleUrls: ['./exibir-conteudo-caixa.component.scss']
})
export class ExibirConteudoCaixaComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  public caixaId;
  public loading = true;
  conteudos: ConteudoModel[] = [];
  public RgCaixa;
  displayedColumns = ['rgCaixa', 'rgItem', 'tipoRegistro', 'descricao', 'dataInicial',
  'dataFinal', 'numDocIni','numDocFin', 'origem'];
  dataSource = new MatTableDataSource<ConteudoModel>([]);
  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'top';

  constructor(
    public dialogRef: MatDialogRef<ExibirConteudoCaixaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    iconRegistry: MatIconRegistry,
    private fb: FormBuilder,
    private _snackBar: MatSnackBar,
    sanitizer: DomSanitizer,
    private dialog: MatDialog,
    private conteudoService: ConteudoService) { }

  ngOnInit() {
    console.log(this.data.caixaId);
    this.caixaId = this.data.caixaId;
    this.getItensCaixa(this.caixaId);
  }

  getItensCaixa (idCaixa) {
    this.conteudoService.listaItens(idCaixa).subscribe(data => {
      console.log(data);
      if (data.length > 0) {
        this.RgCaixa = data[0].caixa.rgCaixa;
        console.log(data[0].caixa.rgCaixa);
      } else {
        this.openSnackBarError('Nenhum conteúdo cadastrado nesta Caixa !');
      }
      this.conteudos = data;
      this.dataSource = new MatTableDataSource(this.conteudos);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.loading = false;
    }, err => {
      console.error(err);
      this.loading = false;
      this.openSnackBarError('Erro ao tentar listar o conteúdo desta Caixa !');
    });
  }

  exibirConteudoEletronico(element) {
    const dialogRef = this.dialog.open(ListagemConteudoEletronicoComponent, {
      width: '100%',
      data: {conteudoId: element.id, descricaoConteudo: element.descricaoConteudo}
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(`The dialog was closed - ${result}`);
      console.log(result);
    });
  }

  goToLink(url: string){
    window.open(url, '_blank', 'location=yes,height=570,width=520,scrollbars=yes,status=yes'); // Open new window
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  openSnackBarError(message: string) {
    this._snackBar.open(message,'', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 3000,
      panelClass: ['error-snackbar']
    });
  }

}



// WEBPACK FOOTER //
// /app/src/app/components/caixa/exibir-conteudo-caixa/exibir-conteudo-caixa.component.ts